import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Sähköpostiviestit',
  labels: {
    view_full_message: 'Näytä koko viesti',
    status: 'Tila:',
    on: 'Päällä',
    off: 'Pois',
    next_send: 'Seuraava lähetys: {{date}}.',
  },
  descriptions: {
    welcome:
      'Lähetetään kerran, kun asiakas tilaa markkinointisähköpostisi, lukuun ottamatta ilmoittautumisia kauppasi lomakkeen kautta. Asiakas saa vain yhden viesteistä Tervetuloa, Tervetuloa jäsenklubiin ja Avajaistarjous.',
    welcome_members_club:
      'Lähetetään kerran, kun joku ilmoittautuu kauppasi lomakkeen kautta eikä ilmoittautumisen alennuskoodia ole määritetty, tai liittyy VIP-jäsenlistallesi. Asiakas saa vain yhden viesteistä Tervetuloa, Tervetuloa jäsenklubiin ja Avajaistarjous.',
    storefront_promo:
      'Lähetetään kerran, kun joku ilmoittautuu kauppasi lomakkeen kautta ja ilmoittautumisen alennuskoodi on määritetty. Sähköposti sisältää henkilökohtaisen alennuskoodin.',
    launch_deal:
      'Lähetetään kerran tuoduille asiakkaillesi 30 minuuttia sen jälkeen, kun ravintolasi on avautunut. Asiakkaat, jotka ovat jo saaneet viestin Tervetuloa tai Tervetuloa jäsenklubiin, ohitetaan.',
    we_miss_you:
      'Lähetetään tilaajille, joiden viimeisimmästä tilauksesta on yli 45 päivää. Tarkistetaan joka aamu; asiakas saa viestin enintään kerran 45 päivässä.',
    happy_friday:
      'Lähetetään kaikille tilaajille klo 08.00 UTC joka parillisen kuukauden (helmi-, huhti-, kesä-, elo-, loka- ja joulukuu) ensimmäisenä perjantaina.',
    lazy_sunday:
      'Lähetetään kaikille tilaajille klo 08.00 UTC joka parittoman kuukauden (tammi-, maalis-, touko-, heinä-, syys- ja marraskuu) ensimmäisenä sunnuntaina.',
    loyalty_program:
      'Lähetetään, kun asiakkaan cashback-saldo yltää vähimmäismäärään, jonka hän voi käyttää. Asiakas saa sen enintään kerran 30 päivässä.',
    you_might_also_like:
      'Lähetetään 3 päivää sellaisen tilauksen jälkeen, jossa oli vähintään 2 samaa tuotetta, joiden hinta on vähintään 6,00, ja suosittelee yhtä suosituimmista tuotteistasi. Asiakas saa viestin enintään kerran 30 päivässä.',
  },
  tiles: {
    sends_count: 'Viestejä lähetetty',
    delivery_rate: 'Toimitusprosentti',
    delivered_suffix: 'toimitettu',
    open_rate: 'Avausprosentti',
    opened_suffix: 'avattu',
    click_rate: 'Napsautusprosentti',
    clicked_suffix: 'napsautettu',
    spam_report_rate: 'Roskapostiraporttien osuus',
    spam_reports_suffix: 'raporttia',
    unsubscribe_rate: 'Tilauksen peruutusprosentti',
    unsubscribes_suffix: 'peruutusta',
  },
  toasts: {
    failed_to_update_status: 'Tilan päivitys epäonnistui',
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },

  preview_modal: {
    title: 'Mallin esikatselu',
    labels: {
      subject: 'Aihe:',
      close: 'Sulje',
    },
    toasts: {
      failed_to_load_data: 'Esikatselutietojen lataaminen epäonnistui',
    },
    template_data: {
      recipient_name: '&lt;Etunimi&gt;',
    },
  },
};
